import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  InputElement,
  LabelElement,
  ButtonElement,
  Box,
  Tooltip,
  TooltipIcon,
  TooltipText,
} from "./FloatLabel.styles";

const FloatLabel = props => {
  const { placeholder, size, maxLength, onClick, srcBtn, alt, srcTooltip, ...rest } = props;
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <Box
      {...rest}
      onClick={evt => {
        evt.preventDefault();
      }}
    >
      <InputElement
        {...rest}
        placeholder={placeholder}
        size={size}
        maxLength={maxLength}
        required
        onClick={evt => {
          evt.preventDefault();
        }}
      />

      <LabelElement
        {...rest}
        onClick={evt => {
          evt.preventDefault();
        }}
      >
        {placeholder}
      </LabelElement>

      {srcTooltip && (
        <Tooltip
          className={showTooltip ? "showTooltip" : ""}
          onMouseEnter={() => {
            setShowTooltip(true);
          }}
          onMouseLeave={() => {
            setShowTooltip(false);
          }}
        >
          <TooltipIcon src={srcTooltip} alt="" />
          <TooltipText>
            CVV é o número com três dígitos no verso do seu cartão de crédito.
          </TooltipText>
        </Tooltip>
      )}

      {srcBtn && (
        <>
          <ButtonElement {...rest} onClick={onClick}>
            <img src={srcBtn} alt={alt} />
          </ButtonElement>
        </>
      )}
    </Box>
  );
};

FloatLabel.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  widthMobile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxWidth: PropTypes.number,
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number,
  marginLeft: PropTypes.number,
  marginRight: PropTypes.number,
  buttonWidth: PropTypes.number,
  placeholder: PropTypes.string.isRequired,
  size: PropTypes.number,
  maxLength: PropTypes.number,
  srcBtn: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  srcTooltip: PropTypes.string,
  onClick: PropTypes.func,
};

FloatLabel.defaultProps = {
  width: 212,
  widthMobile: 212,
  boxWidth: 240,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  buttonWidth: 40,
  size: undefined,
  maxLength: undefined,
  srcBtn: undefined,
  src: undefined,
  alt: "",
  srcTooltip: null,
  onClick: null,
};

export default FloatLabel;
